import React from "react";
import { Aside, ListActionButtonProps, useDisclosure } from "sprint-common-web";

import { EditListButton } from "../../../../../../../../../common/components/buttons/EditListButton";
import { RekognitionResultItem } from "../../listing/RekognitionResultItem";
import { OverwriteSegmentForm } from "../forms/OverwriteSegmentForm";

export type OverwriteSegmentButtonProps = ListActionButtonProps<RekognitionResultItem>;

export const OverwriteSegmentButton = (props: OverwriteSegmentButtonProps): JSX.Element => {
    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <>
            <EditListButton onClick={onOpen} />
            <Aside isOpen={isOpen} type="form" headerText={"Overwrite segment"} onDismiss={onClose}>
                <OverwriteSegmentForm segmentId={props.itemId} onCancel={onClose} onSubmit={onClose} />
            </Aside>
        </>
    );
};
